import React from 'react';

import ScratchcardTicketsApi from '../../../../Api/CRM/Modules/ScratchcardTicketsApi';
import ScratchcardTicketsResponse from '../../../../Api/CRM/Responses/ScratchcardTicketsResponse';
import * as formatters from '../../../../utils/formatters';
import ProtectedLink from '../../../elements/ProtectedLink';
import Search from '../../../elements/Search';
import Card from '../../../elements/common/Card';
import ColoredStatus from '../../../elements/common/ColoredStatus';
import FilterByColumn, { Filter } from '../../../elements/common/FilterByColumn';
import SortButton from '../../../elements/common/SortButton';
import { TableCell as Cell } from '../../../elements/common/TableDetailsRow';
import TableHead from '../../../elements/common/TableHead';
import TableLoader from '../../../elements/common/TableLoader';
import Paginator from '../../../elements/paginator';
import useAutoPaginator from '../../../hooks/useAutoPaginator';
import { TicketStatus } from '../../../../Api/CRM/Responses/LotteryTicketResponse';
import {PERMISSION} from "../../../helpers/Permissions";

function TicketScratchcardsPage() {
    const { items, isLoading, auto } = useAutoPaginator<ScratchcardTicketsResponse>((page, params) =>
        ScratchcardTicketsApi.getAll(page, { params })
    );

    return (
        <Card title="All tickets">
            <Search {...auto.search} />
            <FilterByColumn {...auto.filter}>
                <Filter column="status" type="select" options={{ pending: 'pending', played: 'played' }} />
                <Filter column="play_date" label="Play date" type="dateRange" />
                <Filter column="created_at" label="Created at" type="dateRange" />
            </FilterByColumn>
            <TableLoader isLoading={isLoading}>
                <table className="table model-list">
                    <TableHead>
                        <SortButton column="token" {...auto.sort} />
                        <SortButton column="users.email" label="E-mail" {...auto.sort} />
                        <SortButton column="status" label="Status" {...auto.sort} />
                        <SortButton column="sell_amount_gross" label="Sell Price" {...auto.sort} />
                        <SortButton column="prize_gross" label="Prize" {...auto.sort} />
                        <SortButton column="play_date" label="Date of play" {...auto.sort} />
                        <SortButton column="created_at" order="desc" {...auto.sort} />
                    </TableHead>
                    <TicketListTableBody tickets={items} />
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

function TicketListTableBody({ tickets }: { tickets: ScratchcardTicketsResponse[] }) {
    const { formatDateStringWithTimezone, formatCurrency } = formatters;

    return (
        <tbody>
            {tickets.map((ticket) => (
                <tr key={ticket.id}>
                    <Cell>{ticket.token}</Cell>
                    <td key="email">
                        <ProtectedLink
                            url={`/users/${ticket.user_id}`}
                            value={ticket.email}
                            permissions={[PERMISSION.VIEW_USER]}
                        />
                    </td>
                    <Cell>
                        <ColoredStatus status={ticket.status} />
                        {ticket.prize_gross > 0 ? (
                            <ColoredStatus status={TicketStatus.WON} />
                        ) : (
                            <ColoredStatus status={TicketStatus.NOWINNINGS} />
                        )}
                    </Cell>
                    <Cell>{formatCurrency(ticket.sell_amount_gross)}</Cell>
                    <Cell>{formatCurrency(ticket.prize_gross)}</Cell>
                    <Cell>{formatDateStringWithTimezone(ticket.play_date)}</Cell>
                    <Cell>{formatDateStringWithTimezone(ticket.created_at)}</Cell>
                </tr>
            ))}
        </tbody>
    );
}

export default TicketScratchcardsPage;
